<div class="restoring-flow">
    <div class="restoring-flow__blob restoring-flow__blob--orange" aria-hidden="true"></div>
    <div class="restoring-flow__blob restoring-flow__blob--blue" aria-hidden="true"></div>
    <div class="restoring-flow__blob restoring-flow__blob--green" aria-hidden="true"></div>

    <div class="restoring-flow__row">

        <img class="restoring-flow__logo" src="./assets/images/logos/login-logo.png" alt="COMMITLY"/>

        <div class="restoring-flow__card">
            <form class="restoring-flow__form" (ngSubmit)="sendEmail()">
                <button type="submit" hidden tabindex="-1" aria-hidden="true"></button>
                <p class="restoring-flow__heading">{{'RestorePassword.Title' | translate}}</p>

                <div class="restoring-flow__field">
                    <app-input-line-form
                        *ngIf="!isSend"
                        appAutofocus
                        data-test-id="restore-password-email"
                        [control]="email"
                        [type]="'email'"
                        [tabindex]="2"
                        [labelName]="'RestorePassword.Form.EmailLabel' | translate"
                        [placeholder]="'RestorePassword.Form.EmailPlaceholder' | translate"
                        [submitted]="submitPressed"
                        [autocomplete]="'username'"
                    ></app-input-line-form>

                    <div class="restoring-flow__notice" data-test-id="restore-password-notice" *ngIf="isSend">
                        {{'RestorePassword.Form.EmailSent' | translate}}
                    </div>

                    <div class="restoring-flow__error-summary" data-test-id="restore-password-error" *ngIf="errorMessage">
                        <span class="restoring-flow__error">{{errorMessage | translate}}</span>
                    </div>
                </div>

                <ui-text-button *ngIf="!isSend" [tabindex]="6" class="restoring-flow__submit" [buttonStyle]="buttonStyle.Green"
                    data-test-id="restore-password-submit"
                    (click)="sendEmail()"
                    [disabled]="isSubmitting || (submitPressed && email.invalid)">
                    {{'RestorePassword.Form.Submit' | translate}}
                </ui-text-button>

                <div class="restoring-flow__divider"></div>
            </form>

            <div class="restoring-flow__link-row" *ngIf="isRememberedPassword">
                <span>{{'RestorePassword.Form.RememberedPassword' | translate}}</span>
                <a [uiSref]="signInState">
                    {{'RestorePassword.SignIn' | translate}}
                </a>
            </div>
        </div>

    </div>
</div>
